import React from 'react';
import './EtapesCles.css';
import { 
  FaGraduationCap, 
  FaMapMarkerAlt, 
  FaFileAlt, 
  FaBriefcase, 
  FaClipboardList,
  FaBalanceScale,
  FaBrain,
  FaPlane,
  FaHandshake,
  FaUserTie,
  FaLightbulb,
  FaSyncAlt,
  FaUsers,
  FaGlobeAmericas
} from 'react-icons/fa';

const EtapesCles = () => {
  const etapesPendantEtudes = [
    {
      id: 1,
      icon: <FaGraduationCap />,
      title: "Intégration en France",
      description: "Accueil et orientation pour une arrivée réussie en France",
      color: "#1e3c72"
    },
    {
      id: 2,
      icon: <FaFileAlt />,
      title: "Renouvellement de séjour",
      description: "Assistance complète pour le renouvellement de votre titre de séjour étudiant",
      color: "#2a5298"
    },
    {
      id: 3,
      icon: <FaBriefcase />,
      title: "Aide à la recherche de jobs étudiants, stages, alternance",
      description: "Accompagnement pour trouver des opportunités professionnelles pendant vos études",
      color: "#dc143c"
    },
    {
      id: 4,
      icon: <FaClipboardList />,
      title: "Accompagnement administratif (CAF, sécurité sociale, titres de séjour)",
      description: "Guidance pour toutes les démarches administratives essentielles",
      color: "#ff3855"
    },
    {
      id: 5,
      icon: <FaBalanceScale />,
      title: "Accompagnement juridique",
      description: "Conseils et soutien pour vos questions juridiques en tant qu'étudiant étranger",
      color: "#ff8c00"
    },
    {
      id: 6,
      icon: <FaBrain />,
      title: "Soutien psychologique et santé mentale",
      description: "Ressources et accompagnement pour votre bien-être mental",
      color: "#ff6b6b"
    },
    {
      id: 7,
      icon: <FaPlane />,
      title: "Voyage & Tourisme, Entrepreneuriat, Aides Financières, etc…",
      description: "Services complémentaires pour enrichir votre expérience en France",
      color: "#2e8b57"
    }
  ];

  const etapesApresEtudes = [
    {
      id: 8,
      icon: <FaHandshake />,
      title: "Coaching à la recherche d'emploi (CDI)",
      description: "Préparation intensive pour décrocher un emploi permanent en France",
      color: "#8a2be2"
    },
    {
      id: 9,
      icon: <FaUserTie />,
      title: "Conseils pour le changement de statut (étudiant → salarié)",
      description: "Guidance pour la transition vers le statut de salarié",
      color: "#1e90ff"
    },
    {
      id: 10,
      icon: <FaLightbulb />,
      title: "Aide à la création d'entreprise",
      description: "Soutien pour les projets entrepreneuriaux (incubateurs, statuts juridiques)",
      color: "#ffd700"
    },
    {
      id: 11,
      icon: <FaSyncAlt />,
      title: "Suivi du renouvellement de titre de séjour et changement de statut",
      description: "Accompagnement continu pour vos démarches administratives post-diplôme",
      color: "#ff69b4"
    },
    {
      id: 12,
      icon: <FaUsers />,
      title: "Intégration professionnelle via notre réseau de recruteurs",
      description: "Accès à notre réseau d'entreprises partenaires pour votre insertion professionnelle",
      color: "#00ced1"
    },
    {
      id: 13,
      icon: <FaGlobeAmericas />,
      title: "Préparation pour un retour dans le pays d'origine",
      description: "Accompagnement pour un retour réussi après vos études en France",
      color: "#32cd32"
    }
  ];

  return (
    <section className="etapes-section" id="etapes-accompagnement">
      <div className="etapes-background">
        <div className="etapes-glow etapes-glow-1"></div>
        <div className="etapes-glow etapes-glow-2"></div>
        <div className="etapes-pattern"></div>
      </div>

      <div className="etapes-container">
        {/* Header */}
        <div className="etapes-header">
          <h2 className="etapes-title">
            Les étapes clés de notre accompagnement
            <span className="etapes-title-underline"></span>
          </h2>
          <p className="etapes-subtitle">
            Un parcours complet du début de vos études jusqu'à votre insertion professionnelle
          </p>
        </div>

        {/* Timeline principale */}
        <div className="etapes-timeline">
          {/* Section Pendant vos études */}
          <div className="timeline-section">
            <div className="section-header">
              <div className="section-icon" style={{ backgroundColor: '#1e3c72' }}>
                <FaGraduationCap />
              </div>
              <h3 className="section-title">Pendant vos études</h3>
            </div>
            
            <div className="etapes-grid">
              {etapesPendantEtudes.map((etape) => (
                <div className="etape-card" key={etape.id}>
                  <div className="etape-card-inner">
                    <div className="etape-number">{etape.id}</div>
                    <div 
                      className="etape-icon-wrapper"
                      style={{ 
                        background: `linear-gradient(135deg, ${etape.color}, ${etape.color}dd)`,
                        boxShadow: `0 10px 30px ${etape.color}40`
                      }}
                    >
                      <div className="etape-icon">
                        {etape.icon}
                      </div>
                    </div>
                    
                    <h4 className="etape-title">{etape.title}</h4>
                    <p className="etape-description">{etape.description}</p>
                    
                    <div className="etape-line" style={{ backgroundColor: etape.color }}></div>
                  </div>
                </div>
              ))}
            </div>
          </div>

          {/* Transition */}
          <div className="timeline-transition">
            <div className="transition-line"></div>
            <div className="transition-icon">
              <FaGraduationCap />
            </div>
            <div className="transition-text">Après l'obtention du diplôme</div>
          </div>

          {/* Section Après vos études */}
          <div className="timeline-section">
            <div className="section-header">
              <div className="section-icon" style={{ backgroundColor: '#dc143c' }}>
                <FaHandshake />
              </div>
              <h3 className="section-title">Après vos études</h3>
            </div>
            
            <div className="etapes-grid">
              {etapesApresEtudes.map((etape) => (
                <div className="etape-card" key={etape.id}>
                  <div className="etape-card-inner">
                    <div className="etape-number">{etape.id}</div>
                    <div 
                      className="etape-icon-wrapper"
                      style={{ 
                        background: `linear-gradient(135deg, ${etape.color}, ${etape.color}dd)`,
                        boxShadow: `0 10px 30px ${etape.color}40`
                      }}
                    >
                      <div className="etape-icon">
                        {etape.icon}
                      </div>
                    </div>
                    
                    <h4 className="etape-title">{etape.title}</h4>
                    <p className="etape-description">{etape.description}</p>
                    
                    <div className="etape-line" style={{ backgroundColor: etape.color }}></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* Avantages */}
        <div className="etapes-avantages">
          <h3 className="avantages-title">Pourquoi choisir notre accompagnement ?</h3>
          <div className="avantages-grid">
            <div className="avantage-card">
              <div className="avantage-icon" style={{ backgroundColor: '#1e3c7215' }}>
                <FaUsers />
              </div>
              <h4>Accompagnement personnalisé</h4>
              <p>Un suivi adapté à votre parcours et vos objectifs spécifiques</p>
            </div>
            
            <div className="avantage-card">
              <div className="avantage-icon" style={{ backgroundColor: '#dc143c15' }}>
                <FaHandshake />
              </div>
              <h4>Réseau solide</h4>
              <p>Accès à notre réseau d'entreprises, universités et experts</p>
            </div>
            
            <div className="avantage-card">
              <div className="avantage-icon" style={{ backgroundColor: '#2a529815' }}>
                <FaClipboardList />
              </div>
              <h4>Expertise administrative</h4>
              <p>Maîtrise des démarches complexes pour les étudiants étrangers</p>
            </div>
            
            <div className="avantage-card">
              <div className="avantage-icon" style={{ backgroundColor: '#ff385515' }}>
                <FaGlobeAmericas />
              </div>
              <h4>Approche globale</h4>
              <p>De l'arrivée en France jusqu'à l'insertion professionnelle</p>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="etapes-cta">
          <div className="cta-content">
            <h3>Prêt à commencer votre parcours ?</h3>
            <p>
              Rejoignez les milliers d'étudiants étrangers qui ont réussi leur 
              expérience en France grâce à notre accompagnement
            </p>
            <div className="cta-buttons">
              <button className="cta-btn-primary">
                <span>Commencer mon accompagnement</span>
                <svg className="cta-arrow" width="16" height="16" viewBox="0 0 16 16" fill="none">
                  <path d="M8 0L6.59 1.41L12.17 7H0V9H12.17L6.59 14.59L8 16L16 8L8 0Z" fill="currentColor"/>
                </svg>
              </button>
              <button className="cta-btn-secondary">
                <span>En savoir plus</span>
              </button>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default EtapesCles;